export const FAMIGLIE = ["Contrassegno", "Carta", "Wallet", "BNPL", "PayPal", "Bonifico"];
export const DETTAGLI = ["Visa", "Mastercard", "American Express", "Shop Pay", "Apple Pay", "Google Pay", "Klarna", "PayPal", "Contrassegno"];
export const STATI_CONFERMA = ["Confermato", "Annullato"];
export const STATI_ORDINE = ["Aperto", "Chiuso"];
export const STATI_CONSEGNA = ["Consegnato", "Non consegnato", "In transito", "Giacenza"];
export const MOMENTI_ANNULLO = ["Prima", "Dopo"];
export const RESO_VALORI = ["Sì", "No"];
export const EVENTI = ["Nessuno", "Rientro a magazzino", "Riconsegna", "Giacenza"];
export const STATI_INCASSO_COD = ["in_transito", "consegnato_non_incassato", "incassato"];
export const INCASSO_LABELS = {
  in_transito: "In transito",
  consegnato_non_incassato: "Consegnato non incassato",
  incassato: "Incassato",
};

// Colori semantici coerenti in tutta l'app (pastiglie con sfondo tenue)
export const TONO = {
  verde: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rosso: "bg-red-50 text-red-700 border-red-200",
  ambra: "bg-amber-50 text-amber-700 border-amber-200",
  viola: "bg-violet-50 text-violet-700 border-violet-200",
  neutro: "bg-slate-100 text-slate-600 border-slate-200",
};

// Mappe per colonna della griglia ordini: il rosso resta raro e significa un
// problema reale (annullato, non consegnato, rientro, reso); l'ambra segnala
// qualcosa ancora in sospeso o che è costato; i neutri non urlano.
export const CONFERMA_BADGE = { Confermato: TONO.verde, Annullato: TONO.rosso };
export const ORDINE_BADGE = { Aperto: TONO.ambra, Chiuso: TONO.verde };
export const CONSEGNA_BADGE = {
  Consegnato: TONO.verde, "In transito": TONO.ambra,
  "Non consegnato": TONO.rosso, Giacenza: TONO.ambra,
};
export const EVENTO_BADGE = {
  Nessuno: TONO.verde, "Rientro a magazzino": TONO.rosso,
  Riconsegna: TONO.viola, Giacenza: TONO.ambra,
};
export const MOMENTO_BADGE = { Prima: TONO.neutro, Dopo: TONO.ambra };
export const RESO_BADGE = { No: TONO.neutro, "Sì": TONO.rosso };

// Famiglie di pagamento: colori DISTINTI, non semantici — servono a leggere il
// mix di pagamento a colpo d'occhio, non a giudicarlo.
export const FAMIGLIA_BADGE = {
  Contrassegno: "bg-teal-50 text-teal-700 border-teal-200",
  Carta: "bg-indigo-50 text-indigo-700 border-indigo-200",
  PayPal: "bg-sky-50 text-sky-700 border-sky-200",
  Wallet: "bg-violet-50 text-violet-700 border-violet-200",
  BNPL: "bg-cyan-50 text-cyan-700 border-cyan-200",
  Bonifico: "bg-stone-100 text-stone-600 border-stone-300",
};

export const STATO_BADGE = {
  "Consegnato": TONO.verde,
  "Incassato": TONO.verde,
  "incassato": TONO.verde,
  "In transito": TONO.ambra,
  "in_transito": TONO.ambra,
  "Giacenza": TONO.ambra,
  "consegnato_non_incassato": "bg-amber-100 text-amber-800 border-amber-300",
  "Confermato": TONO.verde,
  "Annullato": TONO.rosso,
  "Non consegnato": TONO.rosso,
  "Non applicabile": TONO.neutro,
};

export const SYNC_FIELDS_LABELS = {
  data: "Data", id_ordine_esterno: "N° ordine", nome_cliente: "Cliente",
  totale_ordine_lordo: "Totale lordo", totale_incassato: "Totale incassato",
  stato_conferma: "Stato conferma", stato_ordine: "Stato ordine",
  stato_consegna: "Stato consegna", momento_annullo: "Momento annullo",
  reso: "Reso", evento: "Evento", metodo_famiglia: "Pagamento (famiglia)",
  metodo_dettaglio: "Pagamento (dettaglio)", importo: "Importo ADV",
};
